import {useEffect, useState} from 'react'

import {useFormik} from 'formik'
import {Button, Container, Form as BootstrapForm, Modal} from 'react-bootstrap'
import * as Yup from 'yup'
import {toast} from 'react-toastify'

import {KTCard, KTCardBody, KTIcon} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'

import {useMutation, useLazyQuery} from '@apollo/client'
import {Spinner} from '../../components/Spinner'
import {useGetUser} from '../../hooks/useGetUser'
import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {hasPermission, parseId, parsePrice} from '../../helpers'
import {GET_ALL_PRODUCTS} from '../../graphql/queries/getProducts'
import {EdgeProducts, IProducts, IResCreateUpdateProducts} from '../../graphql/types/productsTypes'
import {CREATE_UPDATE_PRODUCT} from '../../graphql/mutations/productMutations'
import {InputCurrency} from '../../components/InputCurrency'
import {ALL_PERMISSIONS} from '../../helpers/consts'

const TYPE_UNITS = {
  CM3: 'cm3',
  ML: 'ml',
  KG: 'kg',
  M3: 'm3',
} as const

const validationSchema = Yup.object().shape({
  name: Yup.string().required('El nombre es obligatorio'),
  unitType: Yup.string()
    .oneOf(['cm3', 'kg', 'ml', 'm3'], 'Tipo de unidad inválido')
    .required('El tipo de unidad es obligatorio'),
  unitPrice: Yup.string().required('El precio de la unidad es obligatorio'),
})

export const ProductsPage = () => {
  const [gqlGetAllProducts, {data, loading, error, refetch}] = useLazyQuery<IProducts>(
    GET_ALL_PRODUCTS,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const [gqlCreateUpdateProduct, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<IResCreateUpdateProducts>(CREATE_UPDATE_PRODUCT)

  const [searchTerm, setSearchTerm] = useState('')
  const [showModalCreateUpdate, setShowModalCreateUpdate] = useState(false)
  const [idProductEdit, setIdProductEdit] = useState<null | string>(null)
  const [offset, setOffset] = useState(0)
  const [isPagination, setIsPagination] = useState(false)
  const [dataArr, setDataArr] = useState<EdgeProducts[]>([])

  const {/* idOrganization, */ user} = useGetUser()

  const formik = useFormik({
    initialValues: {
      name: '',
      unitType: '',
      unitPrice: '',
      promotion: '',
    },
    validationSchema,
    onSubmit: (values) => {
      // Aquí puedes realizar la acción con los datos enviados por el formulario
      console.log(values)
      /* console.log('idOrganization', idOrganization)
      if (!idOrganization) return */
      gqlCreateUpdateProduct({
        variables: {
          input: {
            ...values,
            unitPrice: values.unitPrice,
            id: idProductEdit ? parseId(idProductEdit) : undefined,
            promotion: idProductEdit ? values.promotion || '0' : undefined,
            // organization: parseId(idOrganization),
          },
        },
      })
    },
  })

  useEffect(() => {
    gqlGetAllProducts({
      variables: {
        offset,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset])

  useEffect(() => {
    if (error) {
      console.log('error', error)
    }
  }, [error])

  useEffect(() => {
    if (!data) return
    if (isPagination) {
      setDataArr((prev) => [...prev, ...data.productList.edges])
      return
    }
    setDataArr(data.productList.edges)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (!dataCreate) return
    if (dataCreate.productCreateUpdate.product?.id) {
      toast.success(`Producto ${idProductEdit ? 'actualizado' : 'creado'} con éxito`)
      setIsPagination(false)
      setOffset(0)
      refetch()
      setShowModalCreateUpdate(false)
      formik.resetForm()
    } else if (dataCreate?.productCreateUpdate.errors?.length > 0) {
      console.log('noooo que falla')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreate])

  useEffect(() => {
    if (errorCreate) {
      console.log('errorCreate', errorCreate)
    }
  }, [errorCreate])

  const handleClose = () => {
    setShowModalCreateUpdate(false)
  }
  console.log('idProductEdit', idProductEdit)
  if (loading && !isPagination) {
    return (
      <div>
        <PageTitle
          breadcrumbs={[
            {
              title: 'CMR',
              path: '/',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
        >
          Lista de productos
        </PageTitle>
        <KTCard>
          <div style={{height: '40vh'}}>
            <KTCardBody className='py-4 d-flex align-items-center justify-content-center h-100'>
              <Spinner />
            </KTCardBody>
          </div>
        </KTCard>
      </div>
    )
  }
  if (!data && !isPagination) return null
  const canterasList = dataArr

  const permissions = user?.tokenAuth.permissions ?? ['']

  return (
    <div>
      <BreadcrumbJeisat
        title='Lista de productos'
        breadcrumb={[
          {
            title: 'CRM',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={
          <>
            {hasPermission(permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_PRODUCTO) ? (
              <Button
                onClick={() => {
                  setShowModalCreateUpdate(true)
                  setIdProductEdit(null)
                }}
                className='d-flex align-items-center gap-1'
              >
                <i className='fa fa-plus' /> Agregar producto
              </Button>
            ) : null}
          </>
        }
      />

      <KTCard>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            {/* begin::Search */}
            <div className='d-flex align-items-center position-relative my-1'>
              <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Buscar producto'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            {/* end::Search */}
          </div>
          {/* begin::Card toolbar */}
          {/*  <div className='card-toolbar'>
            {/* begin::Group actions
            <UsersListToolbar />
            {/* end::Group actions 
          </div> */}
          {/* end::Card toolbar */}
        </div>
        <KTCardBody className='py-4'>
          <div className='table-responsive'>
            <table
              id='kt_table_users'
              className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
            >
              <thead className='fw-bold'>
                <tr className='text-start text-gray-900 fw-bold fs-7 text-uppercase gs-0'>
                  <th>Nombre</th>
                  <th>Unidad</th>
                  <th>Precio</th>
                  <th>Descuento</th>
                  <th />
                </tr>
              </thead>
              <tbody className='text-gray-700'>
                {canterasList.length > 0 ? (
                  canterasList
                    .filter(({node}) => {
                      if (searchTerm.length < 3) return true
                      return node.name.includes(searchTerm)
                    })
                    .map(({node}) => (
                      <tr key={node.id}>
                        <td>{node.name}</td>
                        <td>{node.unitType}</td>
                        <td>{parsePrice(node.unitPrice)}</td>
                        <td>{parsePrice(node.promotion)}</td>
                        <td>
                          <button
                            className='border-0 p-0 m-0 bg-transparent me-4 hover-bg-color-dark text-secondary'
                            onClick={() => {
                              setIdProductEdit(node.id)
                              formik.setValues({
                                name: node.name,
                                unitPrice: node.unitPrice,
                                unitType: TYPE_UNITS[node.unitType],
                                promotion: node.promotion,
                              })
                              setShowModalCreateUpdate(true)
                            }}
                            title='Editar'
                          >
                            <i className='fa fa-pencil' style={{color: 'inherit'}} />
                          </button>
                          {/* <button
                          className='border-0 p-0 m-0 bg-transparent hover-bg-color-dark text-secondary'
                          onClick={() => setIdCanteraEdit(node.id)}
                          title='Ver'
                        >
                          <i className='fa fa-eye' style={{color: 'inherit'}} />
                        </button> */}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No hay productos registrados
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {loading && isPagination && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Spinner size='24px' />
            </div>
          )}
          {data?.productList.pageInfo.hasNextPage && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Button
                size='sm'
                variant='info'
                onClick={() => {
                  setIsPagination(true)
                  setOffset((pre) => pre + 10)
                }}
              >
                Cargar más productos
              </Button>
            </div>
          )}
          {/* {isLoading && <UsersListLoading />} */}
        </KTCardBody>
      </KTCard>

      <Modal show={showModalCreateUpdate} onHide={handleClose}>
        <BootstrapForm onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>{idProductEdit ? 'Editar producto' : 'Crear producto'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container className='d-flex flex-column gap-4'>
              <BootstrapForm.Group controlId='name'>
                <BootstrapForm.Label>Nombre:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese el nombre'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  isInvalid={formik.touched.name && !!formik.errors.name}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.name}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>

              <BootstrapForm.Group controlId='unitType'>
                <BootstrapForm.Label>Tipo de Unidad:</BootstrapForm.Label>
                <BootstrapForm.Select
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.unitType}
                  isInvalid={formik.touched.unitType && !!formik.errors.unitType}
                >
                  <option value=''>Seleccione unidad</option>
                  <option value='m3'>m3</option>
                  <option value='cm3'>cm3</option>
                  <option value='kg'>kg</option>
                  <option value='ml'>ml</option>
                </BootstrapForm.Select>
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.unitType}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>

              <BootstrapForm.Group controlId='unitPrice'>
                <BootstrapForm.Label>Precio:</BootstrapForm.Label>
                <InputCurrency
                  name='unitPrice'
                  placeholder='Ingrese el precio'
                  className={`${
                    formik.touched.unitPrice && !!formik.errors.unitPrice ? 'is-invalid' : ''
                  } form-control`}
                  onValueChange={(value, name) => {
                    if (name) {
                      formik.setFieldValue(name, value)
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.unitPrice}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.unitPrice}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>

              {idProductEdit && (
                <BootstrapForm.Group controlId='promotion'>
                  <BootstrapForm.Label>Precio descuento:</BootstrapForm.Label>
                  <InputCurrency
                    name='promotion'
                    placeholder='Ingrese el precio'
                    className={`${
                      formik.touched.promotion && !!formik.errors.promotion ? 'is-invalid' : ''
                    } form-control`}
                    onValueChange={(value, name) => {
                      if (name) {
                        formik.setFieldValue(name, value)
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.promotion}
                  />
                  <BootstrapForm.Control.Feedback type='invalid'>
                    {formik.errors.promotion}
                  </BootstrapForm.Control.Feedback>
                </BootstrapForm.Group>
              )}
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type='button'
              variant='secondary'
              onClick={() => {
                handleClose()
                setIdProductEdit(null)
                formik.resetForm()
              }}
            >
              Cancelar
            </Button>
            <Button
              type='submit'
              variant='primary'
              disabled={loadingCreate}
              className='d-flex align-items-center gap-2'
            >
              {loadingCreate && <Spinner color='light' size='14px' />}
              {/* <Spinner color='light' size='14px' /> */}
              {idProductEdit ? 'Editar' : 'Crear producto'}
            </Button>
          </Modal.Footer>
        </BootstrapForm>
      </Modal>
    </div>
  )
}
